import { HearthBeatLoader } from '@components/ui';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { LoadingOverlaySC } from './loading-overlay.styled';

type TProps = {
  loading: boolean;
  children?: React.ReactNode;
  text?: string;
  style?: object;
  background?: 'GREY' | 'WHITE' | 'COMPLETE_WHITE';
};

const LoadingOverlay: React.FC<TProps> = ({
  loading,
  children,
  text,
  style,
  background = 'GREY',
}) => (
  <LoadingOverlaySC isLoading={loading} style={style} background={background}>
    <div className="loading-blured">{children}</div>
    {loading ? (
      <div className="loading-overlay">
        {text ? (
          <div className="loading-overlay-text">
            <FormattedMessage id={text} />
          </div>
        ) : null}
        {background === 'GREY' ? (
          <HearthBeatLoader loading size="medium" />
        ) : (
          <HearthBeatLoader loading size="medium" />
        )}
      </div>
    ) : null}
  </LoadingOverlaySC>
);

LoadingOverlay.defaultProps = {
  background: 'WHITE',
};

export default LoadingOverlay;
